export default __webpack_public_path__ + "static/media/case0.b4c425a2.jpg";